import React from 'react';
import PathfindingVisualizer from './PathfindingVisualizer';

function App() {
  return (
    <div className="App">
      <PathfindingVisualizer />
    </div>
  );
}

export default App;
